var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { PopupV2 as Popup } from '../PopupV2';
import { DialogComponent } from './dialog-wrapper';
export const Dialog = DialogComponent;
const getProps = (arg) => {
    const { useModal, showMask, maskBgColor, maskClosable, position, top, left, animate, animateDuration, isControlAnimationIn, popupStyle, maskStyle, beforeClose, onAnimateEnd, onShow, onDismiss, popupSet = {} } = arg, dialogWrapperProps = __rest(arg, ["useModal", "showMask", "maskBgColor", "maskClosable", "position", "top", "left", "animate", "animateDuration", "isControlAnimationIn", "popupStyle", "maskStyle", "beforeClose", "onAnimateEnd", "onShow", "onDismiss", "popupSet"]);
    const popupProps = Object.assign(Object.assign({}, popupSet), { maskStyle,
        useModal,
        showMask,
        maskBgColor,
        maskClosable,
        position,
        top,
        left,
        animate,
        animateDuration,
        isControlAnimationIn,
        popupStyle,
        beforeClose,
        onAnimateEnd,
        onShow,
        onDismiss });
    return [popupProps, dialogWrapperProps];
};
const show = (arg, Component = DialogComponent, showLeftButton = true) => {
    const [popupProps, dialogWrapperProps] = getProps(arg);
    let alert = null;
    alert = Popup.show(Object.assign({ children: (React.createElement(Component, Object.assign({ showLeftButton: showLeftButton }, dialogWrapperProps, { popupStyle: popupProps.popupStyle, componentApi: false, onConfirm: () => {
                var _a;
                (_a = arg === null || arg === void 0 ? void 0 : arg.onConfirm) === null || _a === void 0 ? void 0 : _a.call(arg, {
                    close: () => { var _a; return (_a = alert === null || alert === void 0 ? void 0 : alert.remove) === null || _a === void 0 ? void 0 : _a.call(alert); },
                });
            }, onCancel: () => {
                var _a;
                (_a = arg === null || arg === void 0 ? void 0 : arg.onCancel) === null || _a === void 0 ? void 0 : _a.call(arg, {
                    close: () => { var _a; return (_a = alert === null || alert === void 0 ? void 0 : alert.remove) === null || _a === void 0 ? void 0 : _a.call(alert); },
                });
            } }))) }, popupProps));
    return {
        close: () => {
            alert.remove();
        },
        update: (props) => {
            const [updatePopupProps, updateDialogWrapperProps] = getProps(props);
            alert.update(Object.assign({ children: (React.createElement(Component, Object.assign({ showLeftButton: showLeftButton }, updateDialogWrapperProps, { componentApi: false }))) }, updatePopupProps));
        },
    };
};
Dialog.alert = (props = {}) => {
    return show(props, DialogComponent, false);
};
Dialog.confirm = (props = {}) => {
    return show(props, DialogComponent);
};
export const DialogShow = show;
export default Dialog;
